module.exports = __webpack_public_path__ + "assets/exclusief.1b537648.svg";